var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechbubbleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00234972 13.9959C2.06348 13.9959 3.94252 13.2166 5.3608 11.9366C9.32132 14.1886 13.9999 13.9959 13.9999 13.9959C13.9999 13.9959 8.13764 10.0891 8.00188 2.27565V0H0L0.00234972 13.9959Z",
    fill: "#4F3C7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00244141 12.9962C1.80653 12.9962 3.44917 12.3151 4.69086 11.1945L5.22717 10.7105L5.85525 11.0676C7.64649 12.0861 9.62227 12.5757 11.1993 12.8057C10.8936 12.4695 10.5748 12.091 10.2553 11.6701C8.67753 9.59124 7.0746 6.46088 7.00218 2.29302L7.00203 0H8.00197V2.27565C8.09755 7.7755 11.0304 11.3397 12.7589 12.9683C13.486 13.6533 14 13.9959 14 13.9959C14 13.9959 13.354 14.0225 12.3389 13.9404C10.6222 13.8015 7.84976 13.3518 5.36089 11.9366C3.94261 13.2166 2.06357 13.9959 0.00244141 13.9959V12.9962Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechbubbleRight);
export default __webpack_public_path__ + "static/media/speechbubble_right.6d21c3f06ec7afa3a18ed03f266567f7.svg";
export { ForwardRef as ReactComponent };